import React, { useState } from 'react';
import { Button } from 'react-bootstrap';

import InsightWhyModal from './InsightWhyModal';

import openInNewIcon from '../../assets/img/open-in-new-black.svg';
import AdminIcon from './images/admin-icon.svg';

import './InsightsCard.scss';

function InsightCardSummary({ cardSummary, modalData }) {
  const [showWhyModal, setShowWhyModal] = useState(false);

  if (!cardSummary) return null;

  return (
    <div className="insight-card insight-card--investigation-summary">
      <div className="insight-card__header">
        <h5>Investigation summary</h5>
      </div>

      <div className="insight-card__body">
        <ul className="insight-card__list">
          <li>
            Analyzed <strong>{cardSummary.itemsAnalyzed} items</strong> across <strong>{cardSummary.stagesAnalyzed} stages</strong>
          </li>
          <li>
            Called <strong>{cardSummary.toolsCalled} tools</strong> across <strong>{cardSummary.duration}</strong>
          </li>
          <li>
            Found <strong>{cardSummary.actionableInsights} actionable insights </strong>
          </li>
        </ul>

        {cardSummary.adminInfo && (
          <div className="insight-card__admin-info">
            <h4><img src={AdminIcon} alt="Admin" /> Admin Info</h4>
            <ul className="insight-card__list--bullet">
              <li>
                <span>Cost:</span> <strong>{cardSummary.adminInfo.cost} $</strong>
              </li>
              <li>
                <span>Tokens:</span> <strong>{cardSummary.adminInfo.tokens}</strong>
              </li>
              <li>
                <span>Model:</span> <strong>{cardSummary.adminInfo.model}</strong>
              </li>
            </ul>
          </div>
        )}

        <Button variant="outline-secondary" size="sm" className="btn-detail" onClick={() => setShowWhyModal(true)}>
          Learn how it works <img src={openInNewIcon} alt="#" />
        </Button>

        <InsightWhyModal show={showWhyModal} summary onHide={() => setShowWhyModal(false)} data={modalData} />
      </div>
    </div>
  );
}

export default InsightCardSummary;
